export default __webpack_public_path__ + "static/media/logo-single.b5c616e6.svg";